import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoneyCheckEdit, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { Drawer } from 'antd';
import NoDataToDisplay from '../../../../components/NoDataToDisplay';
import style from './index.scss';
import { convertISOToDateTimeFormat } from '../../../../util/timezone';

export const DrawerNotes = ({ data }) => {
  const [visible, setvisible] = useState(false);
  // const [form] = Form.useForm();

  const showDrawer = () => setvisible(true);

  const onClose = () => setvisible(false);

  // const onSubmit = (values) => {
  //   console.log('Success:', values);
  // };

  return (
    <Fragment>
      <FontAwesomeIcon
        icon={faMoneyCheckEdit}
        className={style.noteIcons}
        onClick={showDrawer}
      />
      <Drawer
        title="Notes"
        width={'384px'}
        onClose={onClose}
        closeIcon={<FontAwesomeIcon icon={faTimes} />}
        headerStyle={{ borderBottom: '0px hidden' }}
        visible={visible}
        bodyStyle={{ paddingBottom: 0 }}>
        {data?.notes === '' ||
        data?.notes === null ||
        data?.notes === undefined ? (
          <NoDataToDisplay />
        ) : (
          <React.Fragment>
            <p className={style.lastUpdated}>
              Last Updated: {convertISOToDateTimeFormat(data?.updatedAt)}
            </p>
            <div className={style.noteList} id="matchingConfig-note">
              {data?.notes}
            </div>
          </React.Fragment>
        )}

        {/* <Form
            layout="vertical"
            onSubmit={onSubmit}
            className={style.drawerForm}
            hideRequiredMark
            scrollToFirstError
            initialValues={{ note: data?.note }}
            form={form}>
            <div>
              <Form.Item
                name="note"
                label="Investigator Notes"
                valu
                rules={[
                  {
                    required: true,
                    message: 'Please Enter Notes',
                  },
                  {
                    message: 'Must be 20-1000 characters (a-z A-Z 0-9 _ - space)',
                    validator: (_, note) => {
                      /^[a-zA-Z0-9]([a-zA-Z0-9\s_-]){19,999}$/.test(note)
                        ? Promise.resolve()
                        : Promise.reject(_.message)
                    }
                  },
                ]}
              >
                <Input.TextArea name="note" rows={5} placeholder="Please input" />
              </Form.Item>
            </div>
            <Form.Item className={style.drawerFooter}>
              <Button onClick={onClose} style={{ marginRight: 8 }}>Cancel</Button>
              <Button color={'#21B4BD'} type="primary" htmlType="submit">Save</Button>
            </Form.Item>
          </Form> */}
      </Drawer>
    </Fragment>
  );
};

DrawerNotes.propTypes = {
  data: PropTypes.object.isRequired
};

export default DrawerNotes;
